<ng-container>
    <!-- mobile view -->
    <div class="row d-block d-lg-none d-xl-none d-xxl-none d-flex justify-content-center" style="z-index: 5;"> 
        <div class="d-flex align-items-center justify-content-center">
            <mdb-form-control class="flex-grow-1">
                <div class="input-group">
                        <span class="catalog-search-icon text-center">
                        <a *ngIf="!loading" role="button" style="color: #000;">
                          <i class="fa fa-search fa-xs" style="padding: 8px;"></i>
                        </a>
                        <a *ngIf="loading" role="button" style="color: #000;">
                        <i
                            class="autocomplete-loader spinner-border"
                            style="height: 16px; width: 16px; position: inherit;"
                            role="status"
                        ></i>
                        </a>
                        </span>
                    <input
                        mdbInput
                        placeholder="Search Products"
                        [ngModel]="searchText | async"
                        (ngModelChange)="onSearchInputChange($event)"
                        [mdbAutocomplete]="autocomplete"
                        type="text"
                        id="autocomplete"
                        class="d-block form-control border-start-0 overflow-scroll catalog-search-input"
                        (keydown)="onKeyDown($event)"
                        (keyup)="onChange($event)"
                        aria-describedby="basic-addon2"
                        />
                </div> 
            </mdb-form-control>
          </div>
          
        <mdb-autocomplete
            #autocomplete="mdbAutocomplete"
            [displayValue]="displayValue"
            (opened)="onOpen()"
            (selected)="goToProductOption($event)"
            >
            <ng-container *ngIf="results | async as options">
                <mdb-option [value]="userInput">Search for "{{userInput}}"</mdb-option>
                <ng-container *ngFor="let option of options">
                  <mdb-option *ngIf="option && option.images" [value]="option.brand + ' - ' + option.style" (click)="goToProduct(option)" style="width: 350px;">
                    <ng-container *ngIf="option.images[0]">
                        <img loading="lazy" [src]="getVendorImageUrl(option)" [alt]="'Product Image of ' + option.brand + ' ' + option.style + ' ' + option.title" class="option-icon rounded-circle me-1">
                            {{ option.brand + ' ' + option.style + ' ' + option.title | ellipsis: 48 }}
                    </ng-container>  
                    <ng-container *ngIf="option.images.front">
                        <img loading="lazy" [src]="getVendorImageUrl2(option.images.front)" [alt]="'Product Image of ' + option.brand + ' ' + option.style + ' ' + option.title" class="option-icon rounded-circle me-1">
                        {{ option.brand + ' ' + option.style + ' ' + option.title | ellipsis: 48 }}
                    </ng-container>
                  </mdb-option>
                </ng-container>
              </ng-container>
              
              
            <div *ngIf="notFound" class="autocomplete-no-results">No results found</div>
        </mdb-autocomplete>
    </div>
    <!-- mobile view -->

    <!-- desktop view -->
    <nav class="d-none d-sm-none d-md-none d-lg-block navbar navbar-expand-lg shadow-0 py-0" style="z-index: 5;">
        <div class="container-fluid catalog-nav-container">

            <!-- Collapsible wrapper -->
            <div class="collapse navbar-collapse" id="navbarLeftAlignExample" mdbCollapse #leftAligned="mdbCollapse">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <!-- Home Button -->
                    <li class="nav-item pe-3">
                      <a class="nav-link nav-link-custom" role="button" (click)="clear()">Home</a>
                    </li>
                    <!-- Brands Dropdown -->
                    <li mdbDropdown class="nav-item dropdown pe-3">
                        <a mdbDropdownToggle class="nav-link dropdown-toggle nav-link-custom" id="dropdownMenu1" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" role="button">Brands</a>
                        <ul mdbDropdownMenu class="dropdown-menu  dropdown-custom rounded-0" aria-labelledby="dropdownMenu1">
                            <div class="container container-dropdown">
                                <div class="row">
                                    <div class="col-md-2 " *ngFor="let brand of brands">
                                        <a class="dropdown-item" style="text-decoration:none;" (click)="filterNavbar('brand', brand)">{{ brand }}</a>
                                    </div>

                                </div>

                            </div>

                        </ul>
                    </li>

                    <!-- Decoration Dropdown -->
                    <li mdbDropdown class="nav-item dropdown pe-3">
                        <a mdbDropdownToggle class="nav-link dropdown-toggle nav-link-custom" id="dropdownMenu1" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" role="button">Decoration</a>
                            <ul mdbDropdownMenu class="dropdown-menu dropdown-custom rounded-0 " aria-labelledby="dropdownMenuButton">
                                <ng-container *ngFor="let decorate of decorations">
                                    <li><a class="dropdown-item" style="text-decoration:none;"  (click)="filterNavbar('decoration', decorate)">{{ decorate | titlecase }}</a></li>
                                </ng-container>
                              </ul>
                    </li>
                    
                    <!-- Categories / Apparel Dropdown  -->
                    <li mdbDropdown class="nav-item dropdown pe-3">
                        <a mdbDropdownToggle class="nav-link dropdown-toggle nav-link-custom" id="dropdownMenu1" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" role="button">Apparel</a>
                        <ul mdbDropdownMenu class="dropdown-menu dropdown-custom rounded-0 " aria-labelledby="dropdownMenu1">
                            <div class="container container-dropdown-category">
                                <div class="row">
                                    <div class="col-md-2 " *ngFor="let category of categories">
                                        <a class="dropdown-item" style="text-decoration:none;" (click)="filterNavbar('categories', category)">{{
                                            category | titlecase }}</a>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </li>
                    <li class="nav-item pe-3">
                        <a class="nav-link nav-link-custom" role="button" (click)="filterNavbar('categories', 'collectibles')">Collectibles</a>
                    </li>
                    <li class="nav-item pe-3">
                        <a class="nav-link nav-link-custom" role="button" (click)="filterNavbar('categories', 'posters')">Poster/Wall Art</a>
                    </li>
                    <li class="nav-item pe-3">
                        <a class="nav-link nav-link-custom" role="button" (click)="filterNavbar('brand', 'private label')">Custom Products</a>
                    </li>
                    <li class="nav-item pe-3">
                        <a class="nav-link nav-link-custom" role="button" (click)="filterNavbar('decoration', 'cut & sew')">Cut & Sew</a>
                    </li>
                    <li class="nav-item pe-3">
                        <a class="nav-link nav-link-custom" role="button" (click)="filterNavbar('brand', 'private label collecxion')">Private Label CollecXion</a>
                    </li>
                </ul>

                    <mdb-form-control>
                        <div class="input-group" style="flex-wrap: nowrap;">
                                <span class="catalog-search-icon">
                                <a *ngIf="!loading" role="button" style="color: #000;">
                                  <i class="fa fa-search fa-xs" style="padding: 8px;"></i>
                                </a>
                                <a *ngIf="loading" role="button" style="color: #000;">
                                <i
                                    class="autocomplete-loader spinner-border"
                                    style="height: 16px; width: 16px; position: inherit;"
                                    role="status"
                                ></i>
                                </a>
                                </span>
                            <input
                                mdbInput
                                placeholder="Search Products"
                                [ngModel]="searchText | async"
                                (ngModelChange)="onSearchInputChange($event)"
                                [mdbAutocomplete]="autocomplete"
                                type="text"
                                id="autocomplete"
                                class="d-none d-sm-none d-md-block form-control border-start-0 overflow-scroll catalog-search-input"
                                (keydown)="onKeyDown($event)"
                                (keyup)="onChange($event)"
                                aria-describedby="basic-addon2"
                                />
                        </div> 
                    </mdb-form-control>
            </div>
        </div>
    </nav>
    <!-- desktop view -->


</ng-container>

